// External dependencies
import { ConnectedRouter } from 'connected-react-router'
import React, { Suspense } from 'react'
import { Provider } from 'react-redux'
import { history, store } from 'store'
import { BreakpointProvider } from 'utils/hoc/breakpointProvider'
import ScrollToTop from 'utils/hoc/scrollToTop'
import PathByI18nSwitcher from 'components/PathByI18nSwitcher'
import Seo from 'components/Seo'
import SentryManager from 'components/SentryProvider'
import { AuthProvider, AppRouter } from 'modules/Auth'

const CookieBanner = React.lazy(() => import('components/CookieBanner'))
const Modal = React.lazy(() => import('modules/Modal'))
const Notifications = React.lazy(() => import('modules/Notifications'))
const OnboardingManager = React.lazy(() => import('modules/Onboarding/OnboardingManager'))

const App = () => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <PathByI18nSwitcher />
      <Seo />
      <BreakpointProvider>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
        <Suspense fallback={<></>}>
          <Modal />
        </Suspense>
        <Suspense fallback={<></>}>
          <OnboardingManager />
        </Suspense>
        <Suspense fallback={<></>}>
          <CookieBanner />
        </Suspense>
      </BreakpointProvider>
      <Suspense fallback={<></>}>
        <Notifications />
      </Suspense>
      <ScrollToTop />
      <SentryManager />
    </ConnectedRouter>
  </Provider>
)

export default App

export { default as Reducer } from './store/reducer'
export { Sagas } from './store/saga'
